import React, {Children, cloneElement, ReactElement, useEffect, useState} from 'react'
import {ChevronDown, ChevronRight, IconProps} from 'react-bootstrap-icons';
import Collapse from 'react-bootstrap/Collapse';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import {NavLink} from "react-router-dom";
import './SideBar.scss'

interface SideBarDropdownProps {
    title : string;
    forceClose? : boolean;
    children : React.ReactNode;
    icon?: ReactElement<IconProps>;
}

export const SideBarDropdown = ({title, children, forceClose, icon} : SideBarDropdownProps) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (forceClose) {
            setOpen(false);
        }
    }, [forceClose])

    return (
        <Container fluid className="sidebar-dropdown">
            <Nav.Item onClick={() => setOpen(!open)} className="nav-link navbar-brand user-select-none ps-0 pe-0 d-flex align-items-center">
                <span className="sidebar-dropdown-title w-100"> {icon}{title} </span> {open ? <ChevronDown className="float-end" size="0.8rem" /> :
                                <ChevronRight className="float-end" size="0.8rem" />}
            </Nav.Item>
            <Collapse in={open}>
                <div>
                    {Children.map(children as React.ReactElement , (child) =>
                        cloneElement(child, {
                            forceClose: !open
                        })
                    )}
                </div>
            </Collapse>
        </Container>
    )
}

interface SideBarItemProps {
    title : string;
    link : string;
    icon?: ReactElement<IconProps>;
}

export const SideBarItem = ({title, link, icon} : SideBarItemProps) => {
    return (
        <Container fluid>
            <Nav.Item className="nav-pills user-select-none sidebar-item">
                {/*
                    NavLink will add the active class if the browser path matches the path set in the to property
                    See https://reactrouter.com/en/main/components/nav-link
                */}
                <NavLink to={link} className="nav-link navbar-brand ps-0 pe-0"><div className="sidebar-item-title">{icon}{title}</div></NavLink>
            </Nav.Item>
        </Container>
    )
}

interface SideBarProps {
    children : React.ReactNode;
    className?: string;
}

export const SideBar = ({children, className} : SideBarProps) => {
    return <Nav className={`flex-column sidebar-nav ${className}`}>{children}</Nav>
}

SideBar.Item = SideBarItem;
SideBar.Dropdown = SideBarDropdown;